<template>
    <div>
        <div class="content ht-100v pd-0">
            <div class="content-body pd-10">
                <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                                <li class="breadcrumb-item">
                                    <router-link to="/payments/">Payments</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">Funds Transfer - Single</li>
                            </ol>
                        </nav>
                        <h4 class="mg-b-0 tx-spacing--1">Funds Transfer Single</h4>
                    </div>
                    <div class="d-none d-md-block">

                        <button v-if="this.screen === 'val'"
                                class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="upload">
                            <template v-if="ft.ftLoading">
                                    <span class="spinner-border spinner-border-sm text-secondary" role="status">
                                    </span>
                            </template>
                            <filter-icon v-else class="wd-10 mg-r-5"></filter-icon>
                            Validate
                        </button>
                        <b-button v-if="this.screen === 'val' || this.screen === '' " class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"
                                  v-b-modal.account-modal>
                            <plus-icon class="wd-10 mg-r-5"></plus-icon>
                            Add Transaction
                        </b-button>
                       <b-button v-if="this.screen === 'val' || this.screen === '' " class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"
                                  @click="openSingleTransactionModal">
                            <plus-icon class="wd-10 mg-r-5"></plus-icon>
                           Single Transaction
                        </b-button>
                        <button v-if="this.screen === 'validate'" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"  @click="push">
                            <template v-if="ft.authloading">
                                    <span class="spinner-border spinner-border-sm text-secondary" role="status">
                                    </span>
                            </template>
                            <ArchiveIcon v-else size="3x" class="wd-10 mg-r-5" />
                            Push To Queue
                        </button>

                    </div>
                </div>
                <native-card :carditems="ft.cards"></native-card>

                <hr>
                <funds-transfer-table
                        :items="transactions"
                        :fields="fields"
                        :is-busy="ft.ftLoading"
                        :accounts="getaccounts"></funds-transfer-table>
            </div>
        </div><!-- content -->


        <b-modal id="account-modal" v-show="showmultiple" :hide-header="true" ref="account-modal" :hide-footer="true" :centered="true">
            <div class="modal-body">
                <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" @click="hide">&times;</span>
                </a>

                <div>
                    <h4>Initiate Transfer</h4>
                    <p class="tx-color-03">Initiate Transfer</p>
                    <b-form @submit.prevent="initTrans">

                        <b-form-group
                                label="Amount:"
                                class="form-group"
                                label-for="amount"
                                description="amount to be sent to beneficiary.">
                            <b-form-input
                                    id="amount"
                                    v-model="init.amount"
                                    type="number"
                                    step="0.01"
                                    required
                                    placeholder="Enter Amount">
                            </b-form-input>

                        </b-form-group>

                        <b-form-group
                                label="Credit Account:"
                                class="form-group"
                                label-for="creditaccount"
                                description="Enter Credit Account">
                            <b-form-input
                                    id="creditaccount"
                                    v-model="init.creditaccount"
                                    type="number"
                                    required
                                    placeholder="Enter Credit Account"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label="Benefeciary Name:"
                                class="form-group"
                                label-for="amount"
                                description="Beneficiary Name">
                            <b-form-input
                                    id="craccountname"
                                    v-model="init.craccountname"
                                    type="text"
                                    required
                                    placeholder="Enter Beneficiary Name"
                            ></b-form-input>

                        </b-form-group>

                        <b-form-group
                                label="Narration:"
                                class="form-group"
                                label-for="narration"
                                description="Enter Narration">
                            <b-form-input
                                    id="narration"
                                    v-model="init.narration"
                                    type="text"
                                    required
                                    placeholder="Enter Narration"
                            ></b-form-input>

                        </b-form-group>


                        <b-form-group
                                label="Credit Bank:"
                                class="form-group"
                                label-for="creditbank"
                                description="select your beneficiary bank"
                        >
                            <b-form-select
                                    id="creditbank"
                                    v-model="init.creditbank"
                                    :options="banklist"
                                    @change="logbank"
                                    required
                            >
                                <template v-slot:first v-if="bankloading">
                                    <option value="">-- loading --</option>
                                </template>
                            </b-form-select>
                        </b-form-group>


                        <base-button
                                class="mt-3"
                                :loading="ft.ftLoading"
                                title="Submit"
                        ></base-button>

                    </b-form>


                </div>
            </div><!-- modal-body -->
        </b-modal>
        <b-modal :hide-header="true" id="singleFt" :hide-footer="true" :centered="true">
            <div class="modal-body">
                <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" @click="hide('singleFt')">&times;</span>
                </a>

                <div>
                    <h4>Initiate Single Transfer</h4>
                    <p class="tx-color-03">Initiate Single Transfer</p>
                    <b-form @submit.prevent="singletrans">


                      <p-check v-model="toggleBeneficiary" color="primary" class="p-switch p-fill float-right">Pick Beneficiary</p-check>
                      <br>

                      <slot v-if="toggleBeneficiary">
                        <b-form-group class="form-group" label="Select Beneficiary:">
                          <b-form-select v-model="beneficiaryDetails" :options="beneficiaryOption">
                            <template v-slot:first>
                              <option value="">-- none --</option>
                            </template>
                          </b-form-select>
                        </b-form-group>
                      </slot>

                      <slot v-else>
                        <b-form-group
                                label="Credit Bank:"
                                class="form-group"
                                label-for="creditbank"
                                description="select your beneficiary bank"
                        >
                            <b-form-select
                                    id="creditbank"
                                    v-model="singleft.creditbank"
                                    :options="banklist"
                                    @change="logbank"
                                    required
                            >
                                <template v-slot:first v-if="bankloading">
                                    <option value="">-- loading --</option>
                                </template>
                            </b-form-select>
                        </b-form-group>


                        <b-form-group
                                label="Credit Account:"
                                class="form-group"
                                label-for="creditaccount"
                                description="Enter Credit Account">
                            <b-form-input
                                    @keyup="done"
                                    id="creditaccount"
                                    v-model="singleft.creditaccount"
                                    type="number"
                                    required
                                    placeholder="Enter Credit Account"
                            ></b-form-input>
                        </b-form-group>

                        <div v-if="ft.bankloading && singleft.craccountname === ''" class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <b-form-group v-if="singleft.craccountname !== ''"
                                label="Benefeciary Name:"
                                class="form-group"
                                label-for="amount"
                                description="Beneficiary Name">
                            <b-form-input
                                    id="craccountname"
                                    v-model="singleft.craccountname"
                                    type="text"
                                    readonly
                            ></b-form-input>
                        </b-form-group>

                      </slot>

                        <b-form-group
                                label="Amount:"
                                class="form-group"
                                label-for="amount"
                                description="amount to be sent to beneficiary.">
                            <b-form-input
                                    id="amount"
                                    v-model="singleft.amount"
                                    type="number"
                                    step="0.01"
                                    required
                                    placeholder="Enter Amount">
                            </b-form-input>

                        </b-form-group>


                        <b-form-group class="form-group" label="Debit Account:">
                                <b-form-select v-model="singleft.debit" :options="getaccounts" @change="tst">
                                    <template v-slot:first>
                                        <option value="">-- none --</option>
                                    </template>
                                </b-form-select>
                        </b-form-group>



                        <b-form-group
                                label="Narration:"
                                class="form-group"
                                label-for="narration"
                                description="Enter Narration">
                            <b-form-input
                                    id="narration"
                                    v-model="singleft.narration"
                                    type="text"
                                    required
                                    placeholder="Enter Narration"
                            ></b-form-input>

                        </b-form-group>

                        <p-check v-if="!toggleBeneficiary" v-model="singleft.saveben" color="success" class="p-switch p-fill">Save Beneficiary</p-check>


                      <base-button
                                class="mt-3"
                                :loading="ft.ftLoading"
                                title="Push to Queue"
                        ></base-button>


                    </b-form>


                </div>
            </div><!-- modal-body -->
        </b-modal>
    </div>


</template>

<script>
    import FundsTransferTable from "../../components/table/FundsTransferTable";
    import {ArchiveIcon, FilterIcon, PlusIcon} from "vue-feather-icons";
    import {mapState, mapGetters} from 'vuex'
    import NativeCard from "../../components/card/NativeCard";
    import BaseButton from "../../components/button/BaseButton";

    export default {
        name: 'FundsTransferSingle',
        components: {
            FundsTransferTable,
            PlusIcon,FilterIcon, ArchiveIcon,
            NativeCard, BaseButton
        },
        data() {
            return {
                showmultiple: false,
                toggleBeneficiary: false,
                beneficiaryDetails: {},
                cards: [
                    {
                        id: 0,
                        name: 'Hello World',
                        number: '0.81%',
                        color: 'bg-primary'
                    },
                    {
                        id: 1,
                        name: 'Unique Purchases',
                        number: '3,137',
                        color: 'bg-orange'
                    },
                    {
                        id: 2,
                        name: 'Avg. Order Value',
                        number: 'NGN306.20',
                        color: 'bg-success'
                    },
                    {
                        id: 3,
                        name: 'Order Quantity',
                        number: '1650',
                        color: 'bg-black-8'
                    }
                ],
                singleft:{
                    debit:{},
                    creditaccount: '',
                    creditbankcode: '',
                    creditbankname: '',
                    craccountname: '',
                    Narration: '',
                    source: 'RUBIESCIB',
                    accountnumber: '',
                    accountname: '',
                    customerid: '',
                    username: '',
                    amount: '',
                    saveben: false
                },
                init: {
                    creditaccount: '',
                    craccountname: '',
                    debitaccount: {},
                    narration: '',
                    creditbank: {},
                    amount: ''
                },
                busy: true,
                model: {},
                screen : '',
                transactions: [],
                fields: [
                    {key: 'serial', label: 'Serial', sortable: true, class: 'text-left'},
                    {key: 'creditbankcode', label: 'Bank Code', sortable: true, class: 'text-left'},
                    {key: 'creditbankname', label: 'Bank Name', sortable: true, class: 'text-left'},
                    {key: 'creditaccount', label: 'Account No', sortable: true, class: 'text-left'},
                    {key: 'craccountname', label: 'BeneficiaryName', sortable: true, class: 'text-left'},
                    {key: 'amount', label: 'Amount', sortable: true, class: 'text-left'},
                    {key: 'nename', label: 'Validation Name', sortable: true, class: 'text-left'},
                    {key: 'status', label: 'Validation Status', sortable: true, class: 'text-left'},
                    {key: 'actions', label: 'Actions'}
                ],
                accountlist: []
            }


        },
        methods: {
            openSingleTransactionModal: function(){
              const request = {customerid : this.authobj.customerid}
              this.$store.dispatch("account/getCompanyBeneficiaries", request)
              this.$bvModal.show('singleFt')
            },
            logacc: function () {
                this.$store.commit("account/updateTransactions", this.init.debitaccount);
            },
            logbank: function () {
                this.$store.commit("ft/UPDATE_CURR_BANK", this.init.creditbank);
            },
            tst: async function(){
                console.log(this.singleft.debit)
            },
            initTrans() {

                const trans = {
                    craccountname: this.init.craccountname,
                    creditaccount: this.init.creditaccount,
                    creditbankname: this.init.creditbank.bankname,
                    creditbankcode: this.init.creditbank.bankcode,
                    transtatus: "",
                    amount: this.init.amount,
                    narration: this.init.narration,
                    nename: "",
                    status: ""
                };
                console.log(JSON.stringify(trans));
                this.screen = 'val';
                this.transactions.unshift(trans);

                this.$store.commit("ft/UPDATE_TRANSACTIONS", this.transactions);
                this.init = {};
                this.$refs['account-modal'].hide()

            },
            singletrans: async function(){
              if (this.toggleBeneficiary){
                this.singleft = {
                  craccountname: this.beneficiaryDetails.accountname,
                  creditaccount: this.beneficiaryDetails.accountnumber,
                  creditbankname: this.beneficiaryDetails.bankname,
                  creditbankcode: this.beneficiaryDetails.bankcode,
                  username: this.authobj.username,
                  accountname : this.singleft.debit.accountname,
                  amount : this.singleft.amount,
                  accountnumber : this.singleft.debit.accountnumber,
                  customerid: this.authobj.customerid,
                  narration: this.singleft.narration,
                  source: this.singleft.source,
                  saveben: false
                }
              }else {
                this.singleft.accountname = this.singleft.debit.accountname;
                this.singleft.accountnumber = this.singleft.debit.accountnumber;
                this.singleft.customerid = this.authobj.customerid;
                this.singleft.username = this.authobj.username;
                this.singleft.creditbankcode = this.singleft.creditbank.bankcode;
                this.singleft.creditbankname = this.singleft.creditbank.bankname;
              }
              let resp = await this.$store.dispatch("ft/singleft", this.singleft, {root: true});
              resp.responsecode === '00'? this.hide('singleFt') : '';
              this.$swal({
                  title: resp.responsecode === '00'? 'Success' : 'Warning',
                  text: resp.responsemessage,
                  icon: resp.responsecode === '00'? 'success' : 'warning',
                  showCancelButton: false,
                  confirmButtonText: 'Ok'
              });

            },
            done: async  function(){
                const payload = {
                    bankcode: this.singleft.creditbank.bankcode,
                    accountnumber: this.singleft.creditaccount
                };
                if(this.singleft.creditaccount.length === 10){
                    let resp = await this.$store.dispatch("ft/donameenquiry", payload, {root: true});
                    this.$swal({
                        title: resp.responsecode === '00'? 'Success' : 'Warning',
                        text: resp.responsemessage,
                        icon: resp.responsecode === '00'? 'success' : 'warning',
                        showCancelButton: false,
                        confirmButtonText: 'Ok'
                    });
                    this.singleft.craccountname = resp.accountname;

                }
            },

            hide(modalName) {
                this.$bvModal.hide(modalName)
            },
            upload: async function () {
                this.$refs['account-modal'].hide();
                console.log(JSON.stringify(this.currentacc) === '{}');
                if (JSON.stringify(this.currentacc) === '{}') {
                    this.$swal({
                        title: 'Error',
                        text: 'Please Select Debit Account',
                        icon: 'error',
                        showCancelButton: true,
                        confirmButtonText: 'Ok'
                    });
                } else {
                    this.model.transactions = this.trans;
                    this.model.accountnumber = this.currentacc.accountnumber;
                    this.model.customerid = this.authobj.customerid;
                    this.model.accountname = this.currentacc.accountname;
                    this.model.username = this.authobj.username;
                    this.model.source = 'SINGLE FT';
                    const response = await this.$store.dispatch("ft/uploadSingleFt", this.model, {root: false});
                    if (response.responsecode === '00') {
                        this.$store.commit('ft/UPDATE_TRANSACTIONS', []);
                        this.screen = 'validate';
                        this.tsq()
                    } else {
                        this.$swal({
                            title: 'Error',
                            text: response.responsemessage,
                            icon: 'warning',
                            showCancelButton: false,
                            confirmButtonText: 'Ok'
                        })
                    }
                }

            },
            async tsq() {
                let cond = true;
                while (cond) {
                    let resp = await this.$store.dispatch("ft/readBatchStatus", {
                        batchid: this.ft.batchNumber
                    }, {root: false});
                    await this.$store.dispatch("ft/readBatchTransactions", {
                        batchref: resp.batchid
                    }, {root: false});
                    if (resp.status === 'completed') {
                        let trans = await this.$store.dispatch("ft/readBatchTransactions", {
                            batchref: resp.batchid
                        }, {root: false});
                        this.$store.commit('ft/UPDATE_TRANSACTIONS', trans.trasactions);

                        this.screen = 'validate';
                        cond = false;
                        this.$swal({
                            title: 'Success',
                            text: 'Name Enquiry Validation Complete',
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonText: 'Ok'
                        })
                    }
                }

            },

            push: async function(){
                let model = {
                    userid: this.authobj.username,
                    batchid: this.ft.batchDetails.batchid,
                };
                let result = await this.$store.dispatch("ft/queueBatch", model, {root: false});
                const payload = {customerid: this.authobj.customerid, status: 'completed'};
                this.$swal({
                    title: result.responsecode === '00'? 'Success' : 'Warning',
                    text: result.responsemessage,
                    icon: result.responsecode === '00'? 'success' : 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'Ok'
                });
                await this.$store.dispatch("ft/readAllBatches", payload, {root: false});

                this.$store.commit('ft/UPDATE_TRANSACTIONS', []);
            }

        },
        computed: {
            trans: function () {
                return this.transactions
            },
            getaccounts: function () {
                return this.$store.state.account.accountoption
            },
            banklist: function () {
                return this.$store.state.ft.banklist
            },
            bankloading: function () {
                return this.$store.state.ft.bankloading
            },
            authobj: function () {
                return this.$store.state.auth.response
            },
            currentacc() {
                return this.$store.state.account.currentAccount
            },
            ...mapState(['ft', 'account']),
          ...mapGetters({beneficiaryOption: 'account/beneficiaryOptions'})
        },
        mounted() {
        }
    }


</script>

